import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Step1 from './components/Step1';
import Step2 from './components/Step2';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/step1" element={<Step1 />} />
        <Route path="/step2" element={<Step2 />} />
        <Route path="/" element={<Navigate to="/step1" replace />} />
        <Route path="*" element={<Navigate to="/step1" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
